import React, { useState } from 'react';
import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';

const FaqCard = ({ quest, ans }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className='faq-quest-comp'>
        <div id='greenbox__front' onClick={() => setOpen(!open)}>
          <div id={open ? 'plus-sign-vert-open' : 'plus-sign-vert'}></div>
          <div id='plus-sign-hort'></div>
        </div>
        <div id='faq-quest-title'>
          <LinkifiedText>{quest ? quest : 'loading....'}</LinkifiedText>
        </div>
      </div>

      {open && (
        <div id='ans'>
          <LinkifiedText>{ans}</LinkifiedText>
        </div>
      )}
      <div id='hard-line' />
    </>
  );
};

export default FaqCard;
